// @flow
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import media from '../../styles/media'
import { openContactModal } from '../../actions/modals'

const Component = styled.footer`
  padding: 2rem 0;
  background: #575b6b;
  color: #babbc1;
`

const Heading = styled.h6`
  text-transform: uppercase;
  margin-bottom: 1rem;
`

const FooterLink = styled(Link)`
  color: #fff;
  display: flex;

  &:hover,
  &:focus {
    color: rgba(255, 255, 255, 0.9);
  }
`

const LinkButton = styled.button`
  color: #fff;
  display: flex;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover,
  &:focus {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: underline;
  }
`

const Legal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 80%;

  ${media.mdUp} {
    flex-direction: row;
  }
`

const License = styled.div`
  ${media.mdUp} {
    text-align: right;
  }
`

type Props = {
  openContactModal: Function
}

const Footer = (
  { openContactModal }: Props // eslint-disable-line no-shadow
) => (
  <Component>
    <div className="container">
      <div className="row" style={{ marginBottom: '1rem' }}>
        <div
          className="col-md-3 col-sm-6 col-xs-12"
          style={{ marginBottom: '1rem' }}
        >
          <Heading>Kief Realty</Heading>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/faq">FAQ</FooterLink>
          <FooterLink to="/privacy-policy">Privacy</FooterLink>
          <FooterLink to="/terms-of-service">Terms</FooterLink>
        </div>
        <div
          className="col-md-3 col-sm-6 col-xs-12"
          style={{ marginBottom: '1rem' }}
        >
          <Heading>Buy</Heading>
          <FooterLink to="/properties">Search homes</FooterLink>
          <FooterLink to="/buy-any-home">Buy any home</FooterLink>
          <FooterLink to="/buying-with-us">Our process</FooterLink>
        </div>
        <div
          className="col-md-3 col-sm-6 col-xs-12"
          style={{ marginBottom: '1rem' }}
        >
          <Heading>Sell</Heading>
          <FooterLink to="/sell">Home Valuation</FooterLink>
          <FooterLink to="/hire-us">Hire Us</FooterLink>
        </div>
        <div
          className="col-md-3 col-sm-6 col-xs-12"
          style={{ marginBottom: '1rem' }}
        >
          <Heading>Contact</Heading>
          <LinkButton onClick={openContactModal}>Send a message</LinkButton>
          <FooterLink to="/agents">Team</FooterLink>
        </div>
      </div>
      <Legal>
        <div>
          <div>
            © {new Date().getFullYear()} Kief Realty<sup>TM</sup> All Rights
            Reserved.
          </div>
          <div>Paxton, IL 60957</div>
        </div>
        <License>
          <div>Managing Broker Craig Kief</div>
          <div>
            Licensed by the Illinois Department of Financial and Professional
            Regulation #471.001282
          </div>
        </License>
      </Legal>
    </div>
  </Component>
)

export default connect(
  null,
  { openContactModal }
)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.js